import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

function renderMarkdown(texto) {
  if (!texto) return null;
  return texto.split(/\n\n+/).map((bloco, i) => {
    const linha = bloco.trim();
    if (!linha) return null;
    if (linha.startsWith('## ')) {
      return <h2 key={i} style={{ marginTop: '1.5rem', marginBottom: '0.5rem', fontSize: '1.15rem', fontWeight: 700 }}>{linha.slice(3)}</h2>;
    }
    if (linha.startsWith('# ')) {
      return <h1 key={i} style={{ marginTop: '1.5rem', marginBottom: '0.5rem', fontSize: '1.35rem', fontWeight: 700 }}>{linha.slice(2)}</h1>;
    }
    return <p key={i} style={{ marginBottom: '0.75rem', lineHeight: 1.7 }}>{linha}</p>;
  });
}

export default function InstrucoesPage() {
  const { user, isSuperAdmin } = useAuth();
  const [conteudo, setConteudo] = useState('');
  const [atualizadoEm, setAtualizadoEm] = useState(null);
  const [editando, setEditando] = useState(false);
  const [rascunho, setRascunho] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    async function carregar() {
      const { data } = await supabase
        .from('instrucoes')
        .select('conteudo, atualizado_em')
        .eq('id', 1)
        .single();
      if (data) {
        setConteudo(data.conteudo || '');
        setAtualizadoEm(data.atualizado_em || null);
      }
      setLoading(false);
    }
    carregar();
  }, []);

  function handleEditar() {
    setRascunho(conteudo);
    setEditando(true);
  }

  function handleCancelar() {
    setEditando(false);
    setRascunho('');
  }

  async function handleSalvar() {
    setSaving(true);
    const agora = new Date().toISOString();
    const { error } = await supabase
      .from('instrucoes')
      .update({ conteudo: rascunho, atualizado_em: agora, atualizado_por: user.id })
      .eq('id', 1);
    if (!error) {
      setConteudo(rascunho);
      setAtualizadoEm(agora);
      setEditando(false);
    }
    setSaving(false);
  }

  if (loading) {
    return (
      <div className="loading-full">
        <div className="spinner" style={{ borderTopColor: 'var(--blue)', borderColor: 'var(--border)' }} />
      </div>
    );
  }

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0 }}>Instruções</h1>
          {atualizadoEm && (
            <p style={{ margin: '4px 0 0', color: 'var(--text-muted)', fontSize: 13 }}>
              Última atualização: {format(parseISO(atualizadoEm), "dd/MM/yyyy", { locale: ptBR })}
            </p>
          )}
        </div>
        {isSuperAdmin && !editando && (
          <button className="btn btn-secondary" onClick={handleEditar}>Editar</button>
        )}
      </div>

      <div className="card">
        <div className="card-body">
          {editando ? (
            <>
              <textarea
                className="form-textarea"
                value={rascunho}
                onChange={e => setRascunho(e.target.value)}
                rows={20}
                style={{ width: '100%', fontFamily: 'monospace', fontSize: 14, resize: 'vertical' }}
              />
              <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                <button className="btn btn-primary" onClick={handleSalvar} disabled={saving}>
                  {saving ? 'Salvando…' : 'Salvar'}
                </button>
                <button className="btn btn-secondary" onClick={handleCancelar} disabled={saving}>
                  Cancelar
                </button>
              </div>
            </>
          ) : (
            <div>
              {conteudo ? renderMarkdown(conteudo) : (
                <p style={{ color: 'var(--text-muted)' }}>Nenhum conteúdo cadastrado.</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
